import { component } from 'picoapp';

export default component(async (node) => {
  const btn = node.querySelector('[data-foldout-btn]');
  const content = node.querySelector<HTMLElement>('[data-foldout-content]');

  const initFoldOut = () => {
    btn.addEventListener('click', () => {
      node.classList.toggle('fold-out--active');
      content.hidden = !content.hidden;
    });
  };

  const init = () => {
    initFoldOut();
  };

  init();
});
